import { useCallback, useMemo } from "react";
import { useEventExactness } from "./exactness/useEventExactness";
import { useFamilyExactness } from "./exactness/useFamilyExactness";
import { useNameExactness } from "./exactness/useNameExactness";
import { useOtherFieldsAreExact } from "./exactness/useOtherFieldsExactness";
import { useTimespanMustMatch } from "./matchMode/useTimespanMatchMode";
import { useToggleEventExactness } from "./toggle/useToggleEventExactness";
import { useToggleFamilyExactness } from "./toggle/useToggleFamilyExactness";
import { useToggleNameExactness } from "./toggle/useToggleNameExactness";
import { useToggleOtherFieldExactness } from "./toggle/useToggleOtherFieldExactness";
import { useToggleTimespanMatchMode } from "./toggle/useToggleTimespanMatchMode";

export const useMatchAllTerms = () => {
    const namesAreExact = useNameExactness();
    const eventsAreExact = useEventExactness();
    const familyRelationsAreExact = useFamilyExactness();
    const otherFieldsAreExact = useOtherFieldsAreExact();
    const timespanMustMatch = useTimespanMustMatch();
    const toggleNameExactness = useToggleNameExactness();
    const toggleEventExactness = useToggleEventExactness();
    const toggleFamilyExactness = useToggleFamilyExactness();
    const toggleOtherFieldsExactness = useToggleOtherFieldExactness();
    const toggleTimespanMatchMode = useToggleTimespanMatchMode();

    const matchAllTermsExactly =
        namesAreExact && eventsAreExact && familyRelationsAreExact && otherFieldsAreExact && timespanMustMatch;

    const setMatchAllTermsExactly = useCallback(
        (newValue: boolean) => {
            toggleNameExactness(newValue);
            toggleEventExactness(newValue);
            toggleFamilyExactness(newValue);
            toggleOtherFieldsExactness(newValue);
            toggleTimespanMatchMode(newValue);
        },
        [
            toggleNameExactness,
            toggleEventExactness,
            toggleFamilyExactness,
            toggleOtherFieldsExactness,
            toggleTimespanMatchMode,
        ],
    );

    return useMemo(
        () => ({
            matchAllTermsExactly,
            setMatchAllTermsExactly,
        }),
        [matchAllTermsExactly, setMatchAllTermsExactly],
    );
};
